enum ControlType {
  Select = 'select',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Text = 'text',
}

export default ControlType;
